import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-gray-400 py-8 px-6 text-center text-sm">
    <p>© {new Date().getFullYear()} Khalanga Global Ventures. All rights reserved.</p>
    <p>
      Designed by{' '}
      <a
        href="https://www.getabyte.co.za"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gold hover:underline"
      >
        Getabyte
      </a>
    </p>
  </footer>
  
  );
};

export default Footer;
